import { useMemo } from "react";
import { IncorporacaoBloco } from "../../../../domain/models/incorporacao_bloco";

/**
 * IncorporacaoBlocoItem
 */

type Props = {
  incorporacaoBloco: IncorporacaoBloco;
};

export const IncorporacaoBlocoItem = ({
  incorporacaoBloco,
}: Props) => {

  const header = useMemo(() => {
    let spanSize = 1

    if (incorporacaoBloco.tipo === 1) {
      if (incorporacaoBloco.listaAndares && incorporacaoBloco.listaAndares.length > 0) {
        spanSize = incorporacaoBloco.listaAndares[0].listaImoveis.length + 1;
      }
    } else {
      if (incorporacaoBloco.listaImoveis && incorporacaoBloco.listaImoveis.length > 0) {
        spanSize = incorporacaoBloco.listaImoveis.length;
      }
    }

    return (
      <thead className="bg-gray-200 dark:bg-zinc-800">
        <tr>
          <th
            colSpan={spanSize}
            align="left"
            className="px-4 py-2 text-left text-gray-700 dark:text-zinc-300 font-semibold">
            {incorporacaoBloco.descricao}
          </th>
        </tr>
        <tr>
          <th
            colSpan={spanSize}
            align="left"
            className="px-4 py-2 text-left text-gray-700 dark:text-zinc-300 font-semibold">
            N° Unidades
          </th>
        </tr>
      </thead>
    );
  }, [
    incorporacaoBloco,
  ]);

  const body = useMemo(() => {
    return (
      incorporacaoBloco.tipo === 1 ? (
        <tbody className="bg-white dark:bg-zinc-600">
          {incorporacaoBloco.listaAndares && (
            incorporacaoBloco.listaAndares.slice().reverse().map(x => (
              <tr key={x.idIncorporacaoAndar} className="border-t dark:border-t-zinc-600 hover:bg-gray-50 hover:dark:bg-zinc-700">
                <th align="left" className="px-4 py-2 font-medium text-gray-800 dark:text-zinc-200 min-w-[10rem]">
                  {x.descricao ?? `${x.nroAndar}°`}
                </th>
                {
                  x.listaImoveis.map(y => (
                    <td
                      key={y.idIncorporacaoImovel}
                      className="py-3 text-gray-700 dark:text-zinc-300 justify-center items-center min-w-[7rem]">
                      <div className="w-full flex flex-row justify-center items-center">
                        <span className="cursor-pointer">
                          {y.descricao}
                        </span>
                      </div>
                    </td>
                  ))
                }
              </tr>
            ))
          )}
        </tbody>
      ) : (
        <tbody className="bg-white dark:bg-zinc-600 rounded-b-lg">
          {incorporacaoBloco.listaImoveis && (
            <tr className="border-t dark:border-t-zinc-600 hover:bg-gray-50 hover:dark:bg-zinc-700">
              {
                incorporacaoBloco.listaImoveis.map(x => (
                  <td
                    key={x.idIncorporacaoImovel}
                    className="px-4 py-4 text-gray-700 dark:text-zinc-300 justify-center items-center min-w-[6rem]">
                    <span className="cursor-pointer">{x.descricao}</span>
                  </td>
                ))
              }
            </tr>
          )}
        </tbody>
      )
    );
  }, [
    incorporacaoBloco,
  ]);

  return (
    <div className="flex flex-col relative shadow-lg border dark:border-zinc-600">
      <table className="table-auto border-collapse">
        {header}
        {body}
      </table>
    </div>
  );
}